


































































































































































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { VueEditor } from "vue2-editor";
import { ProviderRecord } from "@/store/modules/types";
import {
  required,
  numeric,
  email,
  minLength,
  maxLength,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";
import moment from "moment";
import ModalHeader from "@/components/ModalHeader.vue";
import { BCard, BTabs, BTab, BCardText } from "bootstrap-vue";
import numeral from "numeral";

@Component({
  components: {
    ModalHeader,
    VueEditor,
    BCard,
    BTabs,
    BTab,
    BCardText,
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("providers", ["providerEntitiesStatus"]),
  },
  validations: {},
})
export default class ProviderEditor extends Vue {
  @Prop(Number) readonly providerId!: number;
  provider: ProviderRecord = {
    id: null,
    name: "",
    npi: "",
    phone: "",
    email: "",
    statusId: "ACT",
    specialtyId: null,
    lang: "",
    locationId: null,
  };

  quill = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
    ],
  };

  files = {
    selected: null as any,
    description: "",
    reference: "",
    list: Array<any>(),
  };

  fileInfo = {
    type: "",
    reference: "",
  };

  attachmentTypes = [
    {
      id: "CON",
      name: "CONTRACT",
    },
    {
      id: "OTH",
      name: "OTHER",
    },
  ];

  fileInput(): HTMLInputElement {
    return document.querySelector("input[type='file']") as HTMLInputElement;
  }

  async getProvider() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch(
        "providers/getProvider",
        this.providerId
      );
      this.provider.id = data.id;
      this.provider.name = data.name;
      this.provider.npi = data.npi;
      this.provider.specialtyId = data.specialtyId;
      this.provider.locationId = data.locationId;
      this.provider.phone = data.phone;
      this.provider.email = data.email;
      this.provider.statusId = data.statusId;
      this.provider.lang = data.lang;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

  async getProviderEntitiesStatus() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch(
        "providers/GetProviderEntitiesStatus"
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async save() {
    /*    if (this.$v.provider && this.$v.provider.$invalid) {
      this.$v.provider.$touch();
      return;
    } */
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("providers/save", this.provider);
      this.$modal.hide("provider-editor");
      this.$emit("provider-saved");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

  async getFiles() {
    try {
      this.files.list = await this.$store.dispatch(
        "providers/getFiles",
        this.providerId
      );
    } catch (error) {
      console.log(error);
    }
  }

  async saveFile() {
     if (!this.fileInfo.type) {
        this.warningModal("Please select an <span class='wm-fw-500'>Type</span>.");
        this.fileInput().value="";
        return;
      }

       if (this.fileInfo.type==='CON' && !this.fileInfo.reference) {
        this.warningModal("Please write a <span class='wm-fw-500'>Reference</span>.");
        this.fileInput().value="";
        return;
      }
    this.$store.commit("main/SET_LOADING", true);
    try {
     
      const { provider, fileInfo } = this;
      const file = this.fileInput().files![0];
      const data = await this.$store.dispatch("providers/saveFile", {
        provider,
        file,
        fileInfo,
      });
      this.getFiles();
      this.fileInfo.type = "";
      this.fileInfo.reference = "";
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

  async saveFileDesc() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const fileId = this.files.selected.id;
      const { providerId } = this;
      const { description } = this.files;
      await this.$store.dispatch("providers/saveFileDesc", {
        providerId,
        fileId,
        description,
      });
      this.files.selected.description = description;
      this.$modal.hide("provider-file-desc");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

  async saveFileRef() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const fileId = this.files.selected.id;
      const { providerId } = this;
      const { reference } = this.files;
      await this.$store.dispatch("providers/saveFileRef", {
        providerId,
        fileId,
        reference,
      });
      this.files.selected.reference = reference;
      this.$modal.hide("provider-file-ref");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

  archiveFile(file) {
    this.$modal.show("dialog", {
      title: "Remove " + file.name,
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$store.commit("main/SET_LOADING", true);
            try {
              const { providerId } = this;
              const fileId = file.id;
              await this.$store.dispatch("providers/archiveFile", {
                providerId,
                fileId,
              });
              this.$modal.hide("dialog");
              this.getFiles();
            } catch (error) {
              console.log(error);
            } finally {
              this.$store.commit("main/SET_LOADING", false);
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }

  warningModal(text) {
    this.$modal.show("dialog", {
      title: "PatientCare",
      text: text,
    });
  }

  fileExt(file) {
    return file.name
      .slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2)
      .toLowerCase();
  }
  fileIsImage(file) {
    const ext = this.fileExt(file);
    const arr = [
      "jpg",
      "jpeg",
      "tiff",
      "gif",
      "bmp",
      "png",
      "webp",
      "svg",
      "ai",
      "eps",
    ];
    return arr.indexOf(ext) >= 0;
  }
  fileIcon(file) {
    if (this.fileIsImage(file)) {
      return "fa-file-image";
    } else {
      const ext = this.fileExt(file);
      switch (ext) {
        case "doc":
        case "docx":
          return "fa-file-word";
        case "xls":
        case "xlsx":
          return "fa-file-excel";
        case "ppt":
        case "pptx":
          return "fa-file-powerpoint";
        case "pdf":
          return "fa-file-pdf";
        case "txt":
          return "fa-file-alt";
        case "zip":
          return "fa-file-archive";
        case "avi":
        case "wmv":
        case "mov":
        case "qt":
        case "flv":
        case "swf":
        case "mpg":
        case "mpe":
        case "mpv":
        case "mp2":
        case "mp4":
        case "m4p":
        case "m4v":
        case "ogg":
        case "mpeg":
        case "webm":
          return "fa-file-video";
        default:
          return "fa-file";
      }
    }
  }
  fileSize(file) {
    return numeral(file.size).format("0 b");
  }
  fileDesc(file) {
    this.files.selected = file;
    this.files.description = file.description;
    this.$modal.show("provider-file-desc");
  }

  fileRef(file) {
    this.files.selected = file;
    this.files.reference = file.reference;
    this.$modal.show("provider-file-ref");
  }

  async fileView(file) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { providerId } = this;
      const { storageId } = file;
      const { uri } = await this.$store.dispatch("providers/getFileUrl", {
        providerId,
        storageId,
      });

      window.open(uri, "_blank");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async fileDownload(file) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { providerId } = this;
      const { storageId } = file;
      const { uri } = await this.$store.dispatch(
        "providers/getFileDownloadUrl",
        {
          providerId,
          storageId,
        }
      );
      window.location.href = uri;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  mounted() {
    this.$store.dispatch("providers/getProviderEntitiesStatus");
    if (this.providerId) {
      this.getProvider();
      this.getFiles();
    }
  }
}
